<template>
  <div>
    <footer class="footer-light">
<!--      <div class="light-layout">-->
<!--        <div class="container">-->
<!--          <section class="small-section border-section border-top-0">-->
<!--            <div class="row">-->
<!--              <div class="col-lg-6">-->
<!--                <div class="subscribe">-->
<!--                  <div>-->
<!--                    <h4>KNOW IT ALL FIRST!</h4>-->
<!--                    <p>Never Miss Anything From Multikart By Signing Up To Our Newsletter.</p>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="col-lg-6">-->
<!--                <form action="https://pixelstrap.us19.list-manage.com/subscribe/post?u=5a128856334b598b395f1fc9b&amp;id=082f74cbda" class="form-inline subscribe-form auth-form needs-validation" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank">-->
<!--                  <div class="form-group mx-sm-3">-->
<!--                    <input type="text" class="form-control" name="EMAIL" id="mce-EMAIL" placeholder="Enter your email" required="required">-->
<!--                  </div>-->
<!--                  <button type="submit" class="btn btn-solid" id="mc-submit">subscribe</button>-->
<!--                </form>-->
<!--              </div>-->
<!--            </div>-->
<!--          </section>-->
<!--        </div>-->
<!--      </div>-->
      <section class="section-b-space light-layout">
        <div class="container">
          <div class="row footer-theme partition-f">
            <div class="col-lg-4 col-md-6">
              <div class="footer-title footer-mobile-title">
                <h4>about</h4>
              </div>
              <div class="footer-contant">
                <div class="footer-logo">
                  <img src="https://www.zerofast.net/assets/images/logo-color.png" style="width: 240px;" alt="">
                </div>
              </div>
            </div>
            <div class="col offset-xl-1">
              <div class="sub-title">
                <div class="footer-title">
                  <h4>为什么选我们</h4>
                </div>
                <div class="footer-contant">
                  <ul class="contact-list">
                    <li>
                      专业技术
                    </li>
                    <li>
                      全球包邮
                    </li>
                    <li>
                      严格品控
                    </li>
                    <li>
                      专业客服
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="sub-title">
                <div class="footer-title">
                  <h4>智能家居网关</h4>
                </div>
                <div class="footer-contant">
                  <ul class="contact-list">
                    <li>
                      无损音乐随心听
                    </li>
                    <li>
                      国内各类视频应用随心播放
                    </li>
                    <li>
                      支持国内所有物联网设备
                    </li>
                    <li>
                      即插即用 无需配置
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col">
              <div class="sub-title">
                <div class="footer-title">
                  <h4>客服微信</h4>
                </div>
                <div class="footer-contant">
                  <img src="https://www.zerofast.net/assets/images/wechat.png" style="width: 200px;" alt="客服微信">
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div class="sub-footer">
        <div class="container">
          <div class="row">
            <div class="col-xl-12 col-md-12 col-sm-24">
              <div class="footer-end">
                <p>
                  国内互联网虚拟专用网业务 <b>B1-20161309</b> |
                  <a href="https://beian.miit.gov.cn" style="color: #333;">沪ICP备20021711号-1</a> |
                  <a href="https://beian.mps.gov.cn/#/query/webSearch?code=31010702007861" style="line-height: 24px; color: #333;"><img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png" style="height: 20px; width: 20px;"/>沪公网安备31010702007861号</a>
                </p>
                <p>
                  <i class="fa fa-copyright" aria-hidden="true"></i> Copyright © 2023-2024. All rights reserved by Zerofast
                </p>
              </div>
            </div>
<!--            <div class="col-xl-6 col-md-6 col-sm-12">-->
<!--              <div class="payment-card-bottom">-->
<!--                <ul>-->
<!--                  <li>-->
<!--                    <a href="#">-->
<!--                      <img src="../assets/images/icon/visa.png" alt="">-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <a href="#">-->
<!--                      <img src="../assets/images/icon/mastercard.png" alt="">-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <a href="#">-->
<!--                      <img src="../assets/images/icon/paypal.png" alt="">-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <a href="#">-->
<!--                      <img src="../assets/images/icon/american-express.png" alt="">-->
<!--                    </a>-->
<!--                  </li>-->
<!--                  <li>-->
<!--                    <a href="#">-->
<!--                      <img src="../assets/images/icon/discover.png" alt="">-->
<!--                    </a>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </div>-->
<!--            </div>-->
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue